import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "../../utils/axiosConfig";
import { useUser } from "../../context/UserContext";
import "../../styles/features/auth/AuthLoadingScreen.css";

function AuthLoadingScreen() {
  return (
    <section className="authLoading">
      <div className="authLoading__card">
        <div className="authLoading__spinner" />
        <h2>Chwila… przygotowujemy Twój profil</h2>
        <p>
          Nie zamykaj strony.
        </p>
      </div>
    </section>
  );
}

export default function RequireProfileCompleted({ children }) {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth0();
  const { user, refreshUser, profileLoading, profileLoaded } = useUser();
  const [slow, setSlow] = useState(false);
  const [retryKey, setRetryKey] = useState(0);


  useEffect(() => {
    if (!isAuthenticated) return;

    setSlow(false);

    const timer = setTimeout(() => {
      setSlow(true);
    }, 15000);

    return () => clearTimeout(timer);
  }, [isAuthenticated, retryKey, profileLoading]);

  useEffect(() => {
    if (!isAuthenticated) return;
    if (profileLoaded) return;

    refreshUser().catch(() => {});
  }, [isAuthenticated, profileLoaded, refreshUser, retryKey]);

  if (isLoading || profileLoading || !profileLoaded) {
    return (
      <AuthLoadingScreen
        slow={slow}
        onRetry={() => {
          setSlow(false);
          setRetryKey((k) => k + 1);
          refreshUser().catch(() => {});
        }}
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!user?.profileCompleted) {
    return <Navigate to="/onboarding" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}

// import { useEffect, useState } from "react";
// import { useAuth0 } from "@auth0/auth0-react";
// import { Navigate, useLocation } from "react-router-dom";
// import axios from "../../utils/axiosConfig";


// export default function RequireProfileCompleted({ children }) {
//   const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
//   const [status, setStatus] = useState({ loading: true, completed: false });
//   const location = useLocation();

//   useEffect(() => {
//     let mounted = true;

//     (async () => {
//       if (!isAuthenticated) {
//         if (mounted) setStatus({ loading: false, completed: false });
//         return;
//       }

//       try {
//         const token = await getAccessTokenSilently({
//           authorizationParams: { audience: "https://someet-api" },
//         });

//       const res = await axios.get("/me");


//         if (mounted) {
//           setStatus({ loading: false, completed: !!res.data.profileCompleted });
//         }
//       } catch {
//         if (mounted) setStatus({ loading: false, completed: false });
//       }
//     })();

//     return () => {
//       mounted = false;
//     };
//   }, [isAuthenticated, getAccessTokenSilently]);

//  if (isLoading || status.loading) return <div style={{ padding: 24 }}></div>; //usunac css

//   if (!isAuthenticated) return <Navigate to="/" replace />;

//   if (!status.completed) {
//     return <Navigate to="/onboarding" replace state={{ from: location.pathname }} />;
//   }

//   return <>{children}</>;
// }
